import { render } from "./RisultatiAnalisiDeiTalenti.vue?vue&type=template&id=61c5324a&scoped=true"
import script from "./RisultatiAnalisiDeiTalenti.vue?vue&type=script&lang=js"
export * from "./RisultatiAnalisiDeiTalenti.vue?vue&type=script&lang=js"

import "./RisultatiAnalisiDeiTalenti.vue?vue&type=style&index=0&id=61c5324a&scoped=true&lang=css"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c5324a"]])

export default __exports__